import L from "leaflet";
import { zoneOverlays } from "../../../util/zoneOverlays";
import React, { useCallback, useEffect, useRef, useState } from "react";
import * as actions from "../Calculator/actions";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Switch,
  TextField,
  Tooltip,
} from "@material-ui/core";
import {
  Search as SearchIcon,
  Room as RoomIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  CenterFocusStrong as CenterFocusStrongIcon,
  Close as CloseIcon,
  ArrowBack as ArrowBackIcon,
} from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import _ from "lodash";
import { toast } from "react-toastify";
import CustomAddModal from "../../../components/Common/CustomAddModal";
import { initialAddtariff } from "../../../constants";
import { getCurrentUserId, getCurrentUserOrganizationId } from "../../../utils";
import {
  createTariffTemplate,
  deleteTariffTemplate,
  getTariffTemplate,
  liveShareTariffTemplate,
  updateTariffTemplate,
} from "./actions";
import { addTariffPdfDownloadAPI } from "./api";
import TariffTemplate from "./tariffTemplate";

export default function PortInformation(props) {
  const { setLoader = () => { }, setIsFullScreen } = props;
  const [tariffData, setTariffData] = useState(initialAddtariff);
  const [allTariffs, setAllTariffs] = useState([]);
  const [tariffList, setTariffList] = useState([]);
  const [portOptions, setPortOptions] = useState([]);
  const [portLoading, setPortLoading] = useState(false);
  const [DeleteConfirmationModel, setDeleteConfirmationModel] = useState(false);
  const [tariffForDeletion, setTariffForDeletion] = useState();
  const [editTariffTemplate, setEditTariffTemplate] = useState(false);
  const [selectedPort, setSelectedPort] = useState({ label: "", value: "" });
  const [selectednewPort, setSelectednewPort] = useState({ label: "", value: "" });
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [openTariffTemplate, setAddTariffTemplate] = useState(false);

  const userId = getCurrentUserId();
  const organizationId = getCurrentUserOrganizationId();
  const mapRef = useRef(null);
  const allMarkersGroupRef = useRef(null);

  const isOwnTemplate = (tariffData?.live_sharing && userId === tariffData.userId) ?? true;

  const markersvg = (count = 0, portName = "", country = "", isSelected = false) => {
    const displayName = portName || "Port Location";
    const pinColor = isSelected ? "#1d4ed8" : "#1e293b";
    const accentColor = isSelected ? "#3b82f6" : "#475569";
    const badgeText = count > 0 ? `${count} Tariff${count > 1 ? "s" : ""}` : "PORT";

    return `
      <div class="maritime-marker-root ${isSelected ? "is-start" : ""}">
        <!-- 1. Sonar Radar Pulse Radiating on Water -->
        <div class="maritime-sonar-emitter">
          <div class="sonar-wave wave-1" style="border-color: ${accentColor};"></div>
          <div class="sonar-wave wave-2" style="border-color: ${accentColor};"></div>
          <div class="sonar-beacon-dot" style="background: ${accentColor};"></div>
        </div>

        <!-- 2. Attached Port Name Pill Label -->
        <div class="maritime-pin-label-card" style="${isSelected ? "border-color: #3b82f6; box-shadow: 0 4px 14px rgba(37,99,235,0.3);" : ""}">
          <span class="pin-role-tag ${isSelected ? "is-start" : ""}">${badgeText}</span>
          <span class="pin-port-title" title="${displayName}">${displayName}</span>
          ${country ? `<span class="pin-country-badge">${country}</span>` : ""}
        </div>

        <!-- 3. Navigation Teardrop Pin -->
        <div class="maritime-pin-stem">
          <svg width="28" height="38" viewBox="0 0 60 81" fill="none" xmlns="http://www.w3.org/2000/svg" class="maritime-pin-vector">
            <path d="M30.0336 80.2488C29.0354 80.2488 28.124 79.8148 27.473 79.0336C21.0496 71.0043 0 43.7918 0 29.9902C0 13.4544 13.4544 0 29.9902 0C46.5261 0 59.9804 13.4544 59.9804 29.9902C59.9804 43.8352 38.9743 71.0477 32.5075 79.0336C31.9433 79.8148 31.0318 80.2488 30.0336 80.2488ZM30.0336 6.72718C17.2303 6.72718 6.81398 17.1435 6.81398 29.9468C6.81398 42.7502 17.2303 53.1664 30.0336 53.1664C42.837 53.1664 53.2533 42.7502 53.2533 29.9468C53.2533 17.1435 42.837 6.72718 30.0336 6.72718Z" fill="${pinColor}"/>
            <path d="M30.0318 49.2165C40.6744 49.2165 49.302 40.589 49.302 29.9464C49.302 19.3038 40.6744 10.6763 30.0318 10.6763C19.3892 10.6763 10.7617 19.3038 10.7617 29.9464C10.7617 40.589 19.3892 49.2165 30.0318 49.2165Z" fill="white"/>
            <circle cx="30" cy="30" r="15" fill="${accentColor}" fill-opacity="0.18"/>
            <text x="30" y="32" fill="${pinColor}" font-weight="600" text-anchor="middle" dominant-baseline="central" font-family="Inter, sans-serif" font-size="20">⚓</text>
          </svg>
        </div>
      </div>
    `;
  };

  // Enable full screen viewport on mount
  useEffect(() => {
    if (setIsFullScreen) {
      setIsFullScreen(true);
    }
    return () => {
      if (setIsFullScreen) {
        setIsFullScreen(false);
      }
    };
  }, [setIsFullScreen]);

  // Initialize Leaflet map once on mount
  useEffect(() => {
    const defaultMapCenter = new L.LatLng(20, 0);
    const defaultZoom = 3;

    const seaDefault = L.tileLayer(
      "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
    );
    const seaMark = new L.TileLayer(
      "http://t1.openseamap.org/seamark/{z}/{x}/{y}.png"
    );
    const seaProfil = new L.TileLayer(
      "https://server.arcgisonline.com/ArcGIS/rest/services/Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}"
    );
    const osm = new L.tileLayer("http://{s}.tile.osm.org/{z}/{x}/{y}.png");
    const Esri_WorldImagery = L.tileLayer(
      "http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
    );
    const Esri_WorldGrayCanvas = L.tileLayer(
      "http://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
    );
    const OpenStreetMap_BlackAndWhite = L.tileLayer(
      "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png"
    );

    const map = new L.Map("map", {
      layers: [seaDefault, seaMark],
      center: defaultMapCenter,
      zoom: defaultZoom,
      editable: true,
      minZoom: 2,
      cursor: true,
    });

    mapRef.current = map;
    allMarkersGroupRef.current = L.featureGroup().addTo(map);

    const baseMaps = {
      Default: seaDefault,
      "Sea profile": seaProfil,
      Imagery: Esri_WorldImagery,
      "Open Street Map": osm,
      Gray: Esri_WorldGrayCanvas,
      "Black & white": OpenStreetMap_BlackAndWhite,
    };

    L.control.layers(baseMaps, zoneOverlays(map), { position: "bottomright" }).addTo(map);
    map.zoomControl.setPosition("bottomleft");

    map.on("baselayerchange", function () {
      seaMark.bringToFront();
    });

    const timer = setTimeout(() => {
      map.invalidateSize();
    }, 200);

    return () => {
      clearTimeout(timer);
      map.remove();
      mapRef.current = null;
    };
  }, []);

  // Handle map resize on sidebar toggle or container size change
  useEffect(() => {
    const t = setTimeout(() => {
      if (mapRef.current) mapRef.current.invalidateSize();
    }, 220);
    return () => clearTimeout(t);
  }, [isSidebarCollapsed]);

  useEffect(() => {
    const mapEl = document.getElementById("map");
    if (!mapEl || typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(() => {
      if (mapRef.current) {
        mapRef.current.invalidateSize();
      }
    });
    observer.observe(mapEl);
    return () => observer.disconnect();
  }, []);

  // Fetch all user/org tariff templates on mount
  const fetchAllTariffTemplates = () => {
    getTariffTemplate({ portIdentifier: "all" })
      .then((res) => {
        const list = res.data || [];
        setAllTariffs(list);
      })
      .catch(() => {
        toast.error("Failed to fetch user tariff templates");
      });
  };

  useEffect(() => {
    fetchAllTariffTemplates();
  }, []);

  // Render all map markers whenever allTariffs or selectedPort changes
  useEffect(() => {
    renderAllPortMarkers(allTariffs, selectedPort);
  }, [allTariffs, selectedPort]);

  const renderAllPortMarkers = (templatesList = [], currentSelected = null) => {
    const map = mapRef.current;
    if (!map || !allMarkersGroupRef.current) return;

    allMarkersGroupRef.current.clearLayers();
    const group = allMarkersGroupRef.current;

    const portMap = {};
    templatesList.forEach((item) => {
      const p = item.selectedPort || item.port;
      if (p && (p.lat || p.lat === 0) && (p.lng || p.lng === 0)) {
        const pId = p.portIdentifier || p.name || `${p.lat}_${p.lng}`;
        if (!portMap[pId]) {
          portMap[pId] = {
            portIdentifier: pId,
            name: p.name || p.port || item.berth || "Port",
            country: p.country || "",
            lat: Number(p.lat),
            lng: Number(p.lng),
            selectedPort: p,
            templates: [],
          };
        }
        portMap[pId].templates.push(item);
      }
    });

    // Ensure currently selected port is also on map if user searched it
    if (currentSelected && currentSelected.lat && currentSelected.lng) {
      const pId = currentSelected.selectedPort?.portIdentifier || currentSelected.label;
      if (!portMap[pId]) {
        portMap[pId] = {
          portIdentifier: pId,
          name: currentSelected.label || currentSelected.port,
          country: currentSelected.selectedPort?.country || "",
          lat: Number(currentSelected.lat),
          lng: Number(currentSelected.lng),
          selectedPort: currentSelected.selectedPort || currentSelected,
          templates: [],
        };
      }
    }

    const portsArray = Object.values(portMap);

    portsArray.forEach((pObj) => {
      const isSelected = currentSelected && (
        (currentSelected.selectedPort?.portIdentifier && currentSelected.selectedPort.portIdentifier === pObj.portIdentifier) ||
        (currentSelected.label === pObj.name)
      );

      const count = pObj.templates.length;
      const svgIcon = L.divIcon({
        html: markersvg(count, pObj.name, pObj.country, isSelected),
        className: "maritime-custom-div-icon",
        iconSize: [0, 0],
        iconAnchor: [0, 0],
        popupAnchor: [0, -42],
      });

      const marker = L.marker([pObj.lat, pObj.lng], { icon: svgIcon });

      marker.on("click", () => {
        handleSelectPortFromMarker(pObj);
      });

      group.addLayer(marker);
    });
  };

  const handleSelectPortFromMarker = (pObj) => {
    const portObj = {
      port: pObj.name,
      selectedPort: pObj.selectedPort,
      lat: pObj.lat,
      lng: pObj.lng,
      label: pObj.name,
      value: pObj.portIdentifier,
    };
    setSelectedPort(portObj);

    // Filter templates for this port
    const filtered = (allTariffs || []).filter((t) => {
      const p = t.selectedPort || t.port;
      const id = p?.portIdentifier || p?.name;
      return id === pObj.portIdentifier || p?.name === pObj.name;
    });
    setTariffList(filtered);
    setIsSidebarCollapsed(false);

    if (mapRef.current && pObj.lat && pObj.lng) {
      mapRef.current.flyTo([pObj.lat, pObj.lng], 6, {
        animate: true,
        duration: 1.2,
      });
    }
  };

  const handleCenterPort = () => {
    if (mapRef.current && selectedPort?.lat && selectedPort?.lng) {
      mapRef.current.flyTo([Number(selectedPort.lat), Number(selectedPort.lng)], 6, {
        animate: true,
        duration: 1,
      });
    }
  };

  const delayPortSearch = useCallback(
    _.debounce((search) => onSearchPortList(search), 400),
    []
  );

  const onSearchPortList = (value) => {
    if (value?.length > 1) {
      setPortLoading(true);
      actions
        .portsByChar(value)
        .then((res) => {
          setPortLoading(false);
          setPortOptions(
            Array.isArray(res.data.list)
              ? res.data.list.map((item) => ({
                ...item,
                portLabel: `${item.name}${item.country ? ` (${item.country})` : ""}`,
              }))
              : []
          );
        })
        .catch(() => {
          setPortLoading(false);
        });
    } else {
      setPortOptions([]);
      setPortLoading(false);
    }
  };

  const onChangePort = (name, value) => {
    if (!value) {
      setSelectedPort({ label: "", value: "" });
      setTariffList([]);
      return;
    }
    const portObj = {
      port: value.name,
      selectedPort: value,
      lat: value.lat || "",
      lng: value.lng || "",
      label: value.name,
      value: value.value,
    };
    setSelectedPort(portObj);

    // Filter templates if existing
    const filtered = (allTariffs || []).filter((t) => {
      const p = t.selectedPort || t.port;
      const id = p?.portIdentifier || p?.name;
      return id === value.portIdentifier || p?.name === value.name;
    });
    setTariffList(filtered);
    setIsSidebarCollapsed(false);

    if (mapRef.current && value.lat && value.lng) {
      mapRef.current.flyTo([Number(value.lat), Number(value.lng)], 6, {
        animate: true,
        duration: 1.2,
      });
    }
  };

  const onChangenewPort = (name, value) => {
    setSelectednewPort({
      port: value?.name || "",
      selectedPort: value,
      lat: value?.lat || "",
      lng: value?.lng || "",
      label: value?.name || "",
      value: value?.value || "",
    });
  };

  const onSubmitConfirm = () => {
    if (editTariffTemplate) {
      const params = {
        templateId: tariffData._id,
        organizationId,
      };
      updateTariffTemplate(params, tariffData)
        .then(() => {
          fetchAllTariffTemplates();
          handleCloseEditTariff();
        })
        .catch((error) => {
          toast.error(error?.data?.message || error?.message || "Failed to update Tariff Template");
        });
    } else {
      const params = {
        userId,
        organizationId,
      };
      createTariffTemplate(params, tariffData)
        .then(() => {
          setAddTariffTemplate(false);
          setTariffData(initialAddtariff);
          fetchAllTariffTemplates();
          setPortOptions([]);
          setSelectednewPort({
            port: "",
            selectedPort: null,
            lat: "",
            lng: "",
            label: "",
            value: "",
          });
        })
        .catch((error) => {
          toast.error(error?.data?.message || error?.message || "Failed to create Tariff Template");
        });
    }
  };

  const calculateTariffRow = (row, tariff) => {
    const unitRate = parseFloat(row.unitRate) || 0;
    const tax = parseFloat(row.tax) || 0;
    const selectedFactors = Array.isArray(row.factors) ? row.factors : [];

    if (selectedFactors.length === 0) {
      return {
        ...row,
        netAmount: 0,
        gross_local: 0,
        gross_tariff: 0,
      };
    }

    const factorValues = {
      "Cargo Quantity": parseFloat(tariff.cargo_quantity) || 1,
      fixed: unitRate,
      Hours: parseFloat(tariff.duration_in_hours) || 1,
      NRT: parseFloat(tariff.nrt) || 1,
      GRT: parseFloat(tariff.grt) || 1,
      "Other Multiplier": parseFloat(tariff.other_multiplier) || 1,
      Day: parseFloat(tariff.duration_in_days) || 1,
    };

    let netAmount = selectedFactors.reduce((acc, factor) => {
      if (factor === "fixed") {
        return factorValues[factor];
      }
      return acc * (factorValues[factor] || 1);
    }, 1);

    if (selectedFactors.includes("fixed")) {
      netAmount *= 1;
    } else {
      netAmount *= unitRate;
    }

    const gross_local = netAmount + netAmount * (tax / 100);
    const exchangeRate = parseFloat(tariff.exchange_rate) || 0;
    const gross_tariff = exchangeRate > 0 ? gross_local / exchangeRate : 0;

    return {
      ...row,
      netAmount,
      gross_local,
      gross_tariff,
    };
  };

  const recalculateTariffData = (data) => {
    const newTariffs = (data.parforma_port_tariff || []).map((row) =>
      calculateTariffRow(row, data)
    );
    const net_amount = newTariffs.reduce((sum, item) => sum + (item.netAmount || 0), 0);
    const total_gross = newTariffs.reduce((sum, item) => sum + (item.gross_local || 0), 0);
    const exchangeRate = parseFloat(data.exchange_rate) || 0;
    const total_exchange_rate = exchangeRate > 0 ? total_gross / exchangeRate : 0;

    return {
      ...data,
      parforma_port_tariff: newTariffs,
      net_amount,
      total_gross,
      total_exchange_rate,
    };
  };

  const handleInputChange = (field, value) => {
    setTariffData((prev) => {
      const updatedData = { ...prev, [field]: value };
      if (field === "duration_in_hours") {
        const numHours = parseFloat(value);
        updatedData.duration_in_days = !isNaN(numHours) ? Math.round(numHours / 24) : value;
      } else if (field === "duration_in_days") {
        const numDays = parseFloat(value);
        updatedData.duration_in_hours = !isNaN(numDays) ? numDays * 24 : value;
      }

      const calcFields = [
        "duration_in_hours",
        "duration_in_days",
        "cargo_quantity",
        "grt",
        "nrt",
        "other_multiplier",
        "exchange_rate",
      ];

      if (calcFields.includes(field)) {
        return recalculateTariffData(updatedData);
      }

      return updatedData;
    });
  };

  const handleAddRow = (index) => {
    setTariffData((prev) => {
      const newRow = {
        label: "",
        unitRate: 0,
        factors: [],
        netAmount: 0,
        tax: 0,
        gross_local: 0,
        gross_tariff: 0,
      };

      const updatedTariffs = [
        ...prev.parforma_port_tariff.slice(0, index + 1),
        newRow,
        ...prev.parforma_port_tariff.slice(index + 1),
      ];

      return recalculateTariffData({
        ...prev,
        parforma_port_tariff: updatedTariffs,
      });
    });
  };

  const handleDeleteRow = (index) => {
    setTariffData((prev) => {
      const updatedTariffs = prev.parforma_port_tariff.filter((_, i) => i !== index);
      return recalculateTariffData({
        ...prev,
        parforma_port_tariff: updatedTariffs,
      });
    });
  };

  const handleRowChange = (index, field, value) => {
    setTariffData((prev) => {
      const newTariffs = [...prev.parforma_port_tariff];
      newTariffs[index] = {
        ...newTariffs[index],
        [field]: value,
      };

      return recalculateTariffData({
        ...prev,
        parforma_port_tariff: newTariffs,
      });
    });
  };

  const handleViewTariff = (data) => {
    setTariffData(data);
    setSelectednewPort(data.port);
    setEditTariffTemplate(true);
  };

  const handleCloseEditTariff = () => {
    setEditTariffTemplate(false);
    setTariffData(initialAddtariff);
  };

  const handleCloseAddTariffModel = () => {
    setAddTariffTemplate(false);
    setTariffData(initialAddtariff);
  };

  const openDeleteConfirmationModel = (id) => {
    setTariffForDeletion(id);
    setDeleteConfirmationModel(true);
  };

  const handleDeleteTariff = () => {
    const params = {
      templateId: tariffForDeletion,
      organizationId,
    };
    deleteTariffTemplate(params)
      .then(() => {
        setDeleteConfirmationModel(false);
        setTariffForDeletion("");
        fetchAllTariffTemplates();
      })
      .catch((error) => {
        toast.error(error?.data?.message || error?.message || "Failed to delete Tariff Template");
      });
  };

  const onDownloadPdf = async () => {
    const result = addTariffPdfDownloadAPI(tariffData);
    return result;
  };

  const handletariffOrgShare = (flag, templateId) => {
    const params = {
      templateId,
    };
    const data = {
      flag,
    };
    liveShareTariffTemplate(params, data)
      .then((res) => {
        if (res.data) {
          setAllTariffs((prev) =>
            prev.map((item) =>
              item._id === templateId ? { ...item, live_sharing: res.data.live_sharing } : item
            )
          );
          setTariffList((prev) =>
            prev.map((item) =>
              item._id === templateId ? { ...item, live_sharing: res.data.live_sharing } : item
            )
          );
        }
      })
      .catch((error) => {
        toast.error(error?.message || error?.data?.message || "Failed to share Tariff Template");
      });
  };

  // Group allTariffs by port to list all user ports in sidebar when no port selected
  const userPortsSummary = React.useMemo(() => {
    const portMap = {};
    (allTariffs || []).forEach((t) => {
      const p = t.selectedPort || t.port;
      if (p && (p.lat || p.lat === 0) && (p.lng || p.lng === 0)) {
        const pId = p.portIdentifier || p.name || `${p.lat}_${p.lng}`;
        if (!portMap[pId]) {
          portMap[pId] = {
            portIdentifier: pId,
            name: p.name || p.port || t.berth || "Port",
            country: p.country || "",
            lat: Number(p.lat),
            lng: Number(p.lng),
            selectedPort: p,
            templatesCount: 0,
          };
        }
        portMap[pId].templatesCount += 1;
      }
    });
    return Object.values(portMap);
  }, [allTariffs]);

  return (
    <div className="w-full h-full flex flex-row overflow-hidden bg-white">
      {/* Left-Hand Sidebar Panel (Signal Ocean Style - On Left Side) */}
      <div
        className={`signal-ocean-panel ${isSidebarCollapsed ? "collapsed" : ""}`}
        onClick={isSidebarCollapsed ? () => setIsSidebarCollapsed(false) : undefined}
        title={isSidebarCollapsed ? "Expand sidebar" : undefined}
      >
        {/* Panel Header */}
        <div
          className="panel-header"
          onClick={isSidebarCollapsed ? () => setIsSidebarCollapsed(false) : undefined}
        >
          {!isSidebarCollapsed && (
            <div className="flex items-center gap-2 overflow-hidden">
              <span
                className="font-medium text-[11px] capitalize whitespace-nowrap"
                style={{ color: "#475569" }}
              >
                {selectedPort?.label ? "Port Tariffs" : "Port Information"}
              </span>
              {selectedPort?.label && (
                <span
                  className="text-[11px] font-medium px-2 py-0.5 rounded whitespace-nowrap inline-flex items-center leading-none capitalize"
                  style={{ background: "#f3f4f6", color: "#475569", border: "1px solid #d1d5db" }}
                >
                  {selectedPort.label}
                </span>
              )}
            </div>
          )}
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setIsSidebarCollapsed(!isSidebarCollapsed);
            }}
            className={isSidebarCollapsed ? "panel-toggle-collapsed" : "panel-toggle-btn"}
            title={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            {isSidebarCollapsed ? (
              <ChevronRightIcon style={{ fontSize: 18 }} />
            ) : (
              <>
                <span className="toggle-label text-[11px] font-medium capitalize">Hide</span>
                <ChevronLeftIcon className="toggle-icon" style={{ fontSize: 14 }} />
              </>
            )}
          </button>
        </div>

        {isSidebarCollapsed ? (
          <div
            className="flex-1 flex items-center justify-center cursor-pointer transition-colors py-4"
            onMouseEnter={(e) => (e.currentTarget.style.background = "#f3f4f6")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "")}
            onClick={() => setIsSidebarCollapsed(false)}
            title="Expand Port Information"
          >
            <span
              style={{
                writingMode: "vertical-rl",
                transform: "rotate(180deg)",
                fontSize: "11px",
                fontWeight: 500,
                color: "#6b7280",
                textTransform: "capitalize",
                userSelect: "none",
              }}
            >
              Port Information
            </span>
          </div>
        ) : (
          <>
            <div className="panel-body">
              {/* MODE 1: Specific Port Selected */}
              {selectedPort?.label ? (
                <>
                  {/* Selected Port Overview Header Box */}
                  <div className="p-2.5 rounded-lg border border-slate-200 bg-slate-50 flex flex-col gap-1.5 flex-shrink-0">
                    <div className="flex items-center justify-between">
                      <div className="inline-flex items-center gap-1.5 min-w-0 leading-none">
                        <RoomIcon style={{ fontSize: 14, color: "#3b82f6", display: "block", flexShrink: 0 }} />
                        <span className="text-[11px] font-medium text-slate-800 truncate capitalize leading-none pt-[1.5px]">
                          {selectedPort.label}
                        </span>
                      </div>
                      <button
                        type="button"
                        className="text-[11px] font-medium text-blue-600 hover:text-blue-800 hover:underline inline-flex items-center gap-0.5 capitalize leading-none"
                        onClick={() => {
                          setSelectedPort({ label: "", value: "" });
                          setTariffList([]);
                        }}
                      >
                        <ArrowBackIcon style={{ fontSize: 12, display: "block", flexShrink: 0 }} />
                        <span className="leading-none pt-[1.5px]">All Ports</span>
                      </button>
                    </div>
                    {selectedPort.selectedPort?.country && (
                      <div className="flex items-center gap-2 pl-5">
                        <span className="text-[11px] font-medium px-1.5 py-0.5 rounded bg-slate-200 text-slate-700 capitalize">
                          {selectedPort.selectedPort.country}
                        </span>
                        {selectedPort.lat && selectedPort.lng && (
                          <span className="text-[11px] font-medium font-mono text-slate-500">
                            {Math.abs(Number(selectedPort.lat)).toFixed(2)}°{Number(selectedPort.lat) >= 0 ? "N" : "S"}, {Math.abs(Number(selectedPort.lng)).toFixed(2)}°{Number(selectedPort.lng) >= 0 ? "E" : "W"}
                          </span>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Tariff Templates List Card */}
                  <div className="voyage-port-locations-card mt-2">
                    <div className="card-header-row">
                      <div className="card-header-left inline-flex items-center gap-1.5 leading-none">
                        <RoomIcon style={{ fontSize: 13, color: "#64748b", display: "block", flexShrink: 0 }} />
                        <span className="text-[11px] font-medium capitalize leading-none pt-[1.5px]">Tariff Templates</span>
                      </div>
                      <span className="card-ports-badge text-[11px] font-medium">{tariffList.length} Templates</span>
                    </div>

                    <div className="port-locations-scroll-area">
                      {tariffList.length > 0 ? (
                        <div className="flex flex-col gap-2 pt-1">
                          {tariffList.map((item, index) => (
                            <div
                              key={index}
                              className="p-2.5 rounded-lg border border-slate-200 bg-white hover:border-blue-400 hover:bg-slate-50 transition-all cursor-pointer shadow-2xs flex flex-col gap-1.5"
                              onClick={() => handleViewTariff(item)}
                            >
                              <div className="flex items-center justify-between">
                                <span className="text-[11px] font-medium text-blue-700 hover:text-blue-900 truncate capitalize">
                                  {item.tariff_name || "Unnamed Tariff"}
                                </span>
                                <div className="flex items-center gap-1">
                                  <Tooltip title="Share with your organization" placement="top" arrow>
                                    <Switch
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handletariffOrgShare(!item.live_sharing, item._id);
                                      }}
                                      color="primary"
                                      checked={item.live_sharing}
                                    />
                                  </Tooltip>
                                  {userId === item.userId && (
                                    <button
                                      type="button"
                                      className="text-slate-400 hover:text-rose-600 p-1 rounded hover:bg-rose-50 transition-colors"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        openDeleteConfirmationModel(item._id);
                                      }}
                                      title="Delete tariff template"
                                    >
                                      <DeleteIcon style={{ fontSize: 14 }} />
                                    </button>
                                  )}
                                </div>
                              </div>
                              {item.tariff_description && (
                                <div className="text-[11px] font-medium text-slate-600 line-clamp-2 leading-relaxed">
                                  {item.tariff_description}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="text-[11px] italic py-8 text-slate-400 font-medium text-center">
                          No tariff templates found for this port.<br />
                          Click 'Create New Tariff Template' below to add one.
                        </div>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                /* MODE 2: All Saved Ports Overview */
                <div className="voyage-port-locations-card">
                  <div className="card-header-row">
                    <div className="card-header-left inline-flex items-center gap-1.5 leading-none">
                      <RoomIcon style={{ fontSize: 13, color: "#64748b", display: "block", flexShrink: 0 }} />
                      <span className="text-[11px] font-medium capitalize leading-none pt-[1.5px]">Saved Port Tariffs</span>
                    </div>
                    <span className="card-ports-badge text-[11px] font-medium">{userPortsSummary.length} Ports</span>
                  </div>

                  <div className="port-locations-scroll-area">
                    {userPortsSummary.length > 0 ? (
                      <div className="flex flex-col gap-1.5 pt-1">
                        {userPortsSummary.map((pObj, idx) => (
                          <div
                            key={idx}
                            className="p-2.5 rounded-lg border border-slate-200 bg-white hover:border-blue-400 hover:bg-blue-50/40 transition-all cursor-pointer shadow-2xs flex items-center justify-between group"
                            onClick={() => handleSelectPortFromMarker(pObj)}
                            title="Click to zoom on map & view tariffs"
                          >
                            <div className="inline-flex items-center gap-2 min-w-0 leading-none">
                              <RoomIcon style={{ fontSize: 14, color: "#3b82f6", display: "block", flexShrink: 0 }} />
                              <div className="flex flex-col min-w-0">
                                <span className="text-[11px] font-medium text-slate-800 group-hover:text-blue-700 truncate capitalize leading-none pt-[1px]">
                                  {pObj.name}
                                </span>
                                {pObj.country && (
                                  <span className="text-[11px] font-medium text-slate-500 capitalize leading-none pt-[2px]">
                                    {pObj.country}
                                  </span>
                                )}
                              </div>
                            </div>
                            <span className="text-[11px] font-medium px-2 py-0.5 rounded bg-slate-100 group-hover:bg-blue-100 text-slate-600 group-hover:text-blue-800 border border-slate-200 group-hover:border-blue-300 capitalize">
                              {pObj.templatesCount} Tariff{pObj.templatesCount > 1 ? "s" : ""}
                            </span>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-[11px] italic py-8 text-slate-400 font-medium text-center">
                        No port tariff templates created yet.<br />
                        Click on any location or search above to create one.
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Pinned Bottom Button */}
            <div className="panel-footer">
              <button
                type="button"
                className="w-full h-8 px-3 rounded-md text-white font-medium text-[11px] tracking-normal transition-all inline-flex items-center justify-center gap-1.5 leading-none capitalize"
                style={{ background: "#1a2332" }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#111827")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "#1a2332")}
                onClick={() => setAddTariffTemplate(true)}
              >
                <AddIcon style={{ fontSize: 14, color: "#ffffff", display: "block", flexShrink: 0 }} />
                <span className="leading-none pt-[1.5px]">Create New Tariff Template</span>
              </button>
            </div>
          </>
        )}
      </div>

      {/* Right-Hand Map Column */}
      <div className="flex-1 h-full relative overflow-hidden z-0">
        <div className="distance-matrix-map" id="map" />

        {/* Floating Compact Search Box & Add Button Overlay */}
        <div className="absolute top-4 left-4 z-[1000] flex flex-col gap-2.5 w-[310px] max-w-[calc(100%-24px)] pointer-events-auto">
          {/* Floating Search Input */}
          <div className="bg-white/95 backdrop-blur-md border border-slate-300 rounded-md shadow-xs hover:shadow-sm px-2.5 py-0.5 inline-flex items-center gap-2 transition-all leading-none">
            <SearchIcon style={{ fontSize: 14, color: "#64748b", flexShrink: 0, display: "block" }} />
            <Autocomplete
              options={portOptions || []}
              value={selectedPort?.selectedPort || null}
              getOptionLabel={(option) => option?.portLabel || option?.name || ""}
              onChange={(e, value) => onChangePort("port", value)}
              className="w-full"
              blurOnSelect
              getOptionSelected={(option, value) => option?.name === value?.name}
              PaperProps={{
                style: {
                  borderRadius: "8px",
                  marginTop: "6px",
                  boxShadow: "0 10px 25px -5px rgba(15, 23, 42, 0.15), 0 8px 10px -6px rgba(15, 23, 42, 0.1)",
                  border: "1px solid #e2e8f0",
                },
              }}
              renderOption={(option) => (
                <div className="inline-flex items-center gap-2 py-0.5 px-1 w-full leading-none">
                  <RoomIcon style={{ fontSize: 14, color: "#475569", flexShrink: 0, display: "block" }} />
                  <span className="text-[11px] font-medium text-slate-800 capitalize leading-none pt-[1.5px]">
                    {option.name || option.label}
                  </span>
                  {option.country && (
                    <span className="text-[11px] font-medium text-slate-400 capitalize leading-none pt-[1.5px]">
                      ({option.country})
                    </span>
                  )}
                </div>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="inline-port-input"
                  placeholder="Search port to jump on map..."
                  onChange={(e) => delayPortSearch(e.target.value)}
                  InputProps={{
                    ...params.InputProps,
                    disableUnderline: true,
                    style: { fontSize: "11px", height: "28px", fontWeight: 500 },
                    endAdornment: (
                      <React.Fragment>
                        {portLoading && <CircularProgress color="inherit" size={12} />}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </div>

          {/* New Tariff Template Button - Stacked Below Input */}
          <button
            type="button"
            className="w-full h-8 px-3 rounded-md text-white font-medium text-[11px] tracking-normal transition-all shadow-xs hover:shadow-sm inline-flex items-center justify-center gap-1.5 leading-none capitalize"
            style={{ background: "#1a2332" }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#111827")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#1a2332")}
            onClick={() => setAddTariffTemplate(true)}
          >
            <AddIcon style={{ fontSize: 14, color: "#ffffff", display: "block", flexShrink: 0 }} />
            <span className="leading-none pt-[1.5px]">New Tariff Template</span>
          </button>
        </div>

          {/* Floating Center Port HUD Button */}
          {selectedPort?.lat && (
            <div className="maritime-map-floating-actions">
              <button
                type="button"
                className="map-recenter-btn text-[11px] font-medium capitalize inline-flex items-center gap-1.5 leading-none"
                onClick={handleCenterPort}
                title="Center map on selected port"
              >
                <CenterFocusStrongIcon style={{ fontSize: 15, display: "block", flexShrink: 0 }} />
                <span className="text-[11px] font-medium capitalize leading-none pt-[1.5px]">Center Port</span>
              </button>
            </div>
          )}
        </div>

      {/* Confirmation & Edit Modals */}
      <Dialog open={DeleteConfirmationModel} onClose={() => setDeleteConfirmationModel(false)}>
        <DialogTitle className="text-lg font-semibold">Confirm Deletion</DialogTitle>
        <DialogContent>
          <p className="text-gray-700">
            Are you sure you want to delete this tariff template? This action cannot be undone.
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteConfirmationModel(false)} className="text-gray-500 hover:text-gray-700">
            Cancel
          </Button>
          <Button
            onClick={handleDeleteTariff}
            className="bg-rose-500 hover:bg-rose-600 text-white px-4 py-2 rounded-md"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <CustomAddModal
        open={openTariffTemplate || editTariffTemplate}
        handleClose={() => {
          editTariffTemplate ? handleCloseEditTariff() : handleCloseAddTariffModel();
        }}
        maxWidth="md"
        isDetailView={!isOwnTemplate}
        saveLabel={editTariffTemplate ? "Update" : "Add"}
        disableClose
        title={`${editTariffTemplate ? "Update" : "Add"} Tariff Template`}
        onSubmitConfirm={onSubmitConfirm}
        isScrollable={true}
        contentPaddingClass="!px-3 !py-1.5"
      >
        <TariffTemplate
          tariffData={tariffData}
          onInputChange={handleInputChange}
          onAddRow={handleAddRow}
          onDeleteRow={handleDeleteRow}
          onRowChange={handleRowChange}
          portOptions={portOptions}
          selectednewPort={selectednewPort}
          onChangenewPort={onChangenewPort}
          delayPortSearch={delayPortSearch}
          portLoading={portLoading}
          onDownloadPdf={onDownloadPdf}
          editTariffTemplate={editTariffTemplate}
          setTariffData={setTariffData}
        />
      </CustomAddModal>
    </div>
  );
}
